function SearchQueryModule(moduleEle) {
  var module = this;
  module.moduleEle = moduleEle;
  module.doneTypingInterval = 300;
  module.typingTimer = 300;

  module.initEvents = function () {
    //console.log('SearchQueryModule.initEvents()');
    var qInputElement = module.moduleEle.find('input[name=q]');
    if (qInputElement !== null && qInputElement.length > 0) {
      qInputElement[0].focus();
    }
    module.moduleEle.on('keyup', 'input', function (e) {
      //console.log('SearchQueryModule.initEvents() keyup: ', e.keyCode);
      var input = cash(this),
        value = input.val(),
        enterPressed = e.keyCode == 13;

      if (!enterPressed && value === input.data('prevVal')) {
        //Stop keys that dont change the input from triggering a search
        return true;
      }

      input.data('prevVal', input.val());

      clearTimeout(module.typingTimer);

      module.typingTimer = setTimeout(function () {
        //console.log('SearchQueryModule.initEvents() setTimeout()');
        if (gtag) {
          gtag('event', 'Search', {
            'event_category': 'Search',
            'event_label': value
          });
        }

        instant.list.fireOnChanged(module);
      }, enterPressed ? 0 : module.doneTypingInterval);
    });
  }
  module.getModuleValue = function () {
    //console.log('getModuleValue()');
    var q = module.moduleEle.find('input[name=q]').val();
    return { q: q };
  }
  module.initEvents();
}
//console.log('PagingModule', PagingModule);
instant.list.settings.moduleClasses['SearchQueryModule'] = SearchQueryModule;